import { render } from "./partGallery.vue?vue&type=template&id=5d39547f"
import script from "./partGallery.vue?vue&type=script&lang=js"
export * from "./partGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__